import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../scripts/functions/AuthProvider";
const ProtectedRoute = ({requiredDepartments=[], requiredGroups=[]}) => {
    const {isAuthenticated, userClaims, isLoading} = useAuth();

    if (isLoading) {
        // console.log("Loading session")
        return null;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace/>
    }

    //Check if the user has a valid department or group. Some may have more than one.
    const departments = userClaims?.departments || [];
    const hasDept = requiredDepartments.length === 0 || requiredDepartments.some(d => departments.includes(d));
    const actions = userClaims?.actions || [];

    const groups = userClaims?.groups || [];
    const hasGroup = requiredGroups.length === 0 || requiredGroups.some(g => groups.includes(g));

    if (groups.includes("superadmin") || actions.includes('*')) {
        return <Outlet/>
    }

    if (hasDept && hasGroup) {
        return <Outlet/>
    } else {
        return <Navigate to="/deny-access" replace/>
    }
}

export default ProtectedRoute;